<template>
    <div :style="{'max-width': '1500px', 'width': '90%', 'margin-left': 'auto', 'margin-right': 'auto', 'margin-top': '10px', 'padding-bottom': '100px'}">
        <!-- <div><h3>New Sale</h3></div> -->
        <b-card style="padding: 5px;" class="hidden-print">
            <h5>Lookup Sale</h5>
            <div>
                <b-form @submit="list_sales" class="d-flex flex-wrap" style="gap: 7px;">
                    <b-form-input style="max-width: 300px; width: 100%; display: inline-block;" v-model="querystring" type="text" required></b-form-input>
                    <b-button size="md" type="submit" variant="primary">Search</b-button>

                    <b-button size="md" variant="success" @click="initItemScan">Scan</b-button>
                </b-form>
            </div>
        </b-card>

        <b-card style="margin-top: 10px; overflow-x: auto;" v-if="sales.length > 0" class="hidden-print">
            <table style="width: 100%;">
                <thead>
                    <tr>
                        <th style="min-width: 100px;" class="ipt_tdhr">
                            INVOICE #
                        </th>
                        <th style="min-width: 100px;" class="ipt_tdhr">
                            SOLD ON
                        </th>
                        <th style="min-width: 200px;" class="ipt_tdhr">
                            SOLD FROM
                        </th>
                        <th style="min-width: 200px;" class="ipt_tdhr">
                            CUSTOMER
                        </th>
                        <th style="min-width: 100px;" class="ipt_tdhr">
                            PHONE
                        </th>
                        <th style="min-width: 100px;" class="ipt_tdhr">
                            EMAIL
                        </th>
                        <th style="min-width: 50px;" class="ipt_tdhr">
                            TOTAL
                        </th>
                        <th style="min-width: 50px;" class="ipt_tdhr">
                            ACTION
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item, sidx in sales" v-bind:key="sidx">
                        <td class="ipt_tdr">
                            <router-link :to="`/sales/viewsale/${item.invoice_id}`" class="invoice-link">
                                {{ item.invoice_id }}
                            </router-link>
                        </td>
                        <td class="ipt_tdr">
                            {{ item.ts }}
                        </td>
                        <td class="ipt_tdr">
                            {{ packet.locsubsdict[item.sold_locsub]}}
                        </td>
                        <td class="ipt_tdr">
                            {{ item.fullname }}
                        </td>
                        <td class="ipt_tdr">
                            {{ item.phone }}
                        </td>
                        <td class="ipt_tdr">
                            {{ item.email }}
                        </td>
                        <td class="ipt_tdr">
                            {{ (item.total || 0.0).toFixed(2) }}
                        </td>
                        <td class="ipt_tdr">
                            <b-button size="sm" variant="success" @click="set_and_show(item)">SHOW</b-button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </b-card>

        <b-overlay :show="invoice_being_loaded" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm" style="margin-top: 10px;">
            <div v-if="invoice.invoice_id" style="border: 1px dashed black; padding: 10px;">
                <ViewSale2 :viewdata="invoice" />
            </div>
            <div v-else>
                <b-alert alert variant="warning" show>{{message}}</b-alert>
            </div>
        </b-overlay>

        <b-modal id="modal-scanner" scrollable title="Scan Item" size="lg" hide-footer>
            <SimpleScanner @scanCompleted="fetchScannedItem" />

        </b-modal>
    </div>
</template>

<script>
    import _ from 'underscore'
    import moment from 'moment'
    import global_vars from '@/utilities/global_vars'
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'
    import ViewSale2 from "@/components/Sales/ViewSale2"
    import SimpleScanner from "@/components/importables/SimpleScanner"

    export default {
        name: "LookupSale",
        components: {Backer, ViewSale2, SimpleScanner},
        data: function(){
            return {
                querystring: null,
                sales: [],
                invoice_id: null,
                invoice: {},
                invoice_being_loaded: null,
                message: "No invoice loaded"
            }
        },
        methods: {
            list_sales: function(e){
                if (e){
                    e.preventDefault();
                }

                let that = this;
                let path = "/api/sales/get_sales_lookup_tool/";
                let data = {userid: this.packet.userDetails.id, query: {invoice_id: this.querystring} };
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.sales = response.data.result;
                    }
                    that.sales_being_loaded = false;
                    return
                }
                let f = function(error) {
                    console.log(error);
                    that.$bvToast.toast(
                        "Error loading sales.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.sales_being_loaded = false;
                    return
                }
                this.sales_being_loaded = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            set_and_show: function(item){
                this.invoice_id = item.invoice_id;
                this.fetch_init();
            },

            fetch_init: function(e){
                if (e){
                    e.preventDefault()
                }
                let path = "/api/sales/get_invoice/"
                let data = {invoice_id: this.invoice_id}
                let that = this;
                let s = function(response){
                    if (response.data.result){
                        that.invoice = response.data.result
                        if (!that.invoice.invoice_id){
                            that.message = "No invoice found."
                        }
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.invoice_being_loaded = false;
                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading invoice. Please try again later.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.invoice_being_loaded = false;
                }
                this.invoice_being_loaded=true;
                this.invoice = {}
                Requestor.postAsyncP(path, data, this, s, f);
            },
            initItemScan: function(e){
                if (e){
                    e.preventDefault();
                }
                this.$bvModal.show("modal-scanner");
            },
            fetchScannedItem: function(val){
                if (val){
                    let split = val.split("|")
                    if (split.length > 0){
                        let invoice_id = split[1];
                        this.invoice_id = invoice_id;
                        this.fetch_init();
                    }
                    else {
                        that.$bvToast.toast(
                            "Cannot read the scanned invoice.",
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                    }
                    this.$bvModal.hide("modal-scanner");
                }
            }
        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
        }
    }
</script>

<style scoped>
.invoice-link {
    color: black;
    cursor: pointer;
     text-decoration: none;
}

.invoice-link:hover {
    color: #0056b3;
    text-decoration: none;
}

.ipt_tdhr {
    font-weight: bold;
    padding: 8px;
    border-bottom: 1px solid #ddd;
}

.ipt_tdr {
    padding: 8px;
    border-bottom: 1px solid #eee;
}

table {
    border-collapse: collapse;
    width: 100%;
}

tr:hover {
    background-color: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/components/Sales/LookupSale.vue